import cx from "classnames";
import { memo } from "react";
import { getInitials } from "@/helpers/getInitials";
import styles from "./PresentationMembers.module.scss";

type UserAvatarProps = {
    name: string;
    color: string;
    isPresenter: boolean;
};

export const UserAvatar = memo(({ name, color, isPresenter }: UserAvatarProps) => {
    const userItemStyles = cx(
        styles.barPanelRightUsersItemView,
        isPresenter && styles.barPanelRightUsersItemIndicatorSelected,
    );

    return (
        <div className={styles.barPanelRightUsersItem}>
            <div className={userItemStyles} style={{ backgroundColor: color }}>
                {getInitials(name)}
            </div>
        </div>
    );
});
